<template>
  <base-section
    id="program"
    :space="0"
  >
    <v-container>
      <div>
        <v-tabs
          id="tab-program"
        >
          <v-tab
            class="font-weight-bold"
            min-width="96"
            text
            :href="`#tab-cfp`"
            @click="goToTop"
            id="cfp"
          >
            Submit a Late Industrial
          </v-tab>
          <v-tab
            class="font-weight-bold"
            min-width="96"
            text
            :href="`#tab-dsa`"
            @click="goToTop"
            id="dsa"
          >
            Distinguished Service Award
          </v-tab>
          <!---
          <v-tab
            class="font-weight-bold"
            min-width="96"
            text
            :href="`#tab-cfp`"
            @click="goToTop"
            id="cfp"
          >
            Call for Contributions
          </v-tab>
          --->
          <v-tab
            class="font-weight-bold"
            min-width="96"
            text
            :href="`#tab-key-dates`"
            @click="goToTop"
            id="key-dates"
          >
            Key Dates
          </v-tab>
          <v-tab
            class="font-weight-bold"
            min-width="96"
            text
            :href="`#tab-topics`"
            @click="goToTop"
            id="topics"
          >
            Topics
          </v-tab>
          <v-tab
            class="font-weight-bold"
            min-width="96"
            text
            :href="`#tab-submission-guidelines`"
            @click="goToTop"
            id="submission-guidelines"
          >
            Submission Guidelines
          </v-tab>
          <v-tab
            class="font-weight-bold"
            min-width="96"
            text
            to="/camera-ready"
            @click="goToTop"
            id="camera-ready"
          >
            Camera-Ready
          </v-tab>
          <v-tab-item
            :value="`tab-dsa`"
          >
            <dsa />
          </v-tab-item>
          <v-tab-item
            :value="`tab-cfp`"
          >
            <call-for-contributions />
          </v-tab-item>
          <v-tab-item
            :value="`tab-key-dates`"
          >
            <keydates />
          </v-tab-item>
          <v-tab-item
            :value="`tab-topics`"
          >
            <topics />
          </v-tab-item>
          <v-tab-item
            :value="`tab-submission-guidelines`"
          >
            <submission-guidelines />
          </v-tab-item>
        </v-tabs>
      </div>
    </v-container>
  </base-section>
</template>
<script>
  import Keydates from './Keydates.vue'
  import CallForContributions from './CallForContributions.vue'
  import Submissions from './Submissions.vue'
  import Topics from './Topics.vue'
  import SubmissionGuidelines from './SubmissionGuidelines.vue'
  import Dsa from './Dsa.vue'
  export default {
    name: 'Program',
    components: { Keydates, CallForContributions, Topics, Submissions, SubmissionGuidelines, Dsa },

    data: () => ({
      tab: null,
      items: [
        'Call For Contributions',
        'Key Dates',
        'Topics',
        'Submissions',
      ],
    }),
    mounted () {
      var section = this.$router.currentRoute.hash.replace('#tab-', '')
      var mobile = this.isMobileDevice()
      if (section && !mobile) {
        document.getElementById(section).click()
      }
      /*  else if (mobile && section) {
        section = section + '-nav'
        document.getElementById(section).click()
        //  window.open('#/' + section, '_parent')
      }
      */
      document.getElementById('tab-program').firstChild.style = 'position: fixed; background-color: #fafafa !important; width = 100%; margin-top: -11px; z-index: 5; width: 100%'
    },
    methods: {
      isMobileDevice () {
        return (typeof window.orientation !== 'undefined') || (navigator.userAgent.indexOf('IEMobile') !== -1)
      },
      goToTop () {
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        })
      },
    },
  }
</script>
